import {Button, Popconfirm, Table, Tooltip} from "antd";
import moment from "moment";
import React from "react";

import {PlayCircleFilled, CheckCircleFilled, EditOutlined, DeleteOutlined} from "@ant-design/icons";
import {useStore} from "../../../../hooks/useStore";
import {UpdatePoolForecastModal} from "../updatePoolForecastModal/UpdatePoolForecastModal";
import {ResponsiveDataTable} from "components/_defaultComponents/ResponsiveDataTable";

export const DailyPoolForecastTable = ({
    poolId,
    data = [],
    setData,
    shiftHours = [],
    loading,
    pagination,
    recall = () => {}
}) => {
    const stores = useStore();
    const currentPage = 1;
    const totalPage = 100;
    const [selectedForecast, setSelectedForecast] = React.useState(null);
    const [updatePoolForecastModalVisible, setUpdatePoolForecastModalVisible] = React.useState(
        false
    );

    const handleChangePage = async page => {
        console.log(page);
    };

    const handleRun = async ({forecast}) => {
        try {
            const result = await stores.poolShiftStore.calculatePoolShiftSlotForecast({
                poolShiftForecastId: forecast._id
            });
            if (result) {
                recall();
            }
        } catch (error) {}
    };
    const handleShow = async ({forecast}) => {
        try {
            const result = await stores.poolShiftStore.showDailyForecast({
                poolShiftForecastId: forecast._id
            });
            if (result) {
                recall();
            }
        } catch (error) {}
    };

    const handleEdit = ({forecast}) => {
        setSelectedForecast(forecast);
        setUpdatePoolForecastModalVisible(true);
    };

    const handleRemove = ({forecast}) => {
        const result = stores.poolShiftStore.removeDailyForecast({
            poolShiftForecastId: forecast._id
        });
        if (result) {
            setData(data.filter(x => x._id !== forecast._id));
            setTimeout(() => {
                recall();
            }, 2000);
        }
    };

    const findShiftHour = id => {
        return (shiftHours || [])?.find(x => x?._id === id) || undefined;
    };

    return (
        <>
            <ResponsiveDataTable
                rowKey="_id"
                loading={loading}
                size="small"
                style={{width: "100%", fontSize: "10px !important"}}
                pagination={
                    !pagination
                        ? false
                        : {
                              total: totalPage,
                              current: currentPage,
                              onChange: handleChangePage,
                              hideOnSinglePage: true,
                              showSizeChanger: false
                          }
                }
                tableLayout="fixed"
                dataSource={data}
                columns={[
                    {
                        title: "Tarih",
                        dataIndex: "date",
                        key: "date",
                        align: "center",
                        onCell: () => ({
                            "data-label": "Tarih"
                        }),
                        render: date => (date ? moment(date).format("DD.MM.YYYY") : "-")
                    },
                    {
                        title: "Başlangıç Saati",
                        dataIndex: "shiftStartHourId",
                        key: "shiftStartHourId",
                        align: "center",
                        render: id => {
                            const shiftHour = findShiftHour(id);
                            return shiftHour ? `${shiftHour?.startTime}` : "-";
                        },
                        onCell: () => ({
                            "data-label": "Başlangıç Saati"
                        })
                    },
                    {
                        title: "Bitiş Saati",
                        dataIndex: "shiftEndHourId",
                        key: "shiftEndHourId",
                        align: "center",
                        render: id => {
                            const shiftHour = findShiftHour(id);
                            return shiftHour ? `${shiftHour.endTime}` : "-";
                        },
                        onCell: () => ({
                            "data-label": "Bitiş Saati"
                        })
                    },
                    {
                        title: "Düzenle",
                        dataIndex: "isCalculated",
                        align: "center",
                        render: (isCalculated, forecast) => (
                            <>
                                <Tooltip
                                    title={
                                        isCalculated ? "Hesaplandığı için güncellenemez" : "Düzenle"
                                    }
                                >
                                    <Button
                                        disabled={isCalculated || updatePoolForecastModalVisible}
                                        icon={<EditOutlined />}
                                        onClick={() => handleEdit({forecast})}
                                    />
                                </Tooltip>
                            </>
                        ),
                        onCell: () => ({
                            "data-label": "Düzenle"
                        })
                    },
                    {
                        title: "Sil",
                        dataIndex: "isShowed",
                        align: "center",
                        render: (isShowed, forecast) => (
                            <>
                                <Tooltip title={isShowed ? "Gösterildiği için silinemez" : "Sil"}>
                                    <Popconfirm
                                        title={"Forecast silinecek, emin misiniz?"}
                                        onConfirm={() => handleRemove({forecast})}
                                        okText="Evet"
                                        cancelText="Hayır"
                                        disabled={isShowed}
                                    >
                                        <Button disabled={isShowed} icon={<DeleteOutlined />} />
                                    </Popconfirm>
                                </Tooltip>
                            </>
                        ),
                        onCell: () => ({
                            "data-label": "Sil"
                        })
                    },
                    {
                        title: "Run",
                        dataIndex: "isCalculated",
                        align: "center",
                        render: (isCalculated, forecast) => (
                            <>
                                <Tooltip title={isCalculated ? "Hesaplandı" : "Hesaplama Yaptır"}>
                                    <Popconfirm
                                        title={"Forecast hesaplanacak, emin misiniz?"}
                                        onConfirm={() => handleRun({forecast})}
                                        okText="Evet"
                                        cancelText="Hayır"
                                        disabled={isCalculated}
                                    >
                                        <Button
                                            disabled={isCalculated}
                                            icon={<PlayCircleFilled />}
                                        />
                                    </Popconfirm>
                                </Tooltip>
                            </>
                        ),
                        onCell: () => ({
                            "data-label": "Run"
                        })
                    },
                    {
                        title: "Show",
                        dataIndex: "isShowed",
                        align: "center",
                        render: (isShowed, forecast) => (
                            <>
                                <Tooltip
                                    title={
                                        !forecast?.isCalculated
                                            ? "Henüz Hesaplanmamış"
                                            : !isShowed
                                            ? "Göster"
                                            : "Gösterimde"
                                    }
                                >
                                    <Popconfirm
                                        title={"Forecast gösterilecek, emin misiniz?"}
                                        onConfirm={() => handleShow({forecast})}
                                        okText="Evet"
                                        cancelText="Hayır"
                                        disabled={isShowed || !forecast?.isCalculated}
                                    >
                                        <Button
                                            disabled={isShowed || !forecast?.isCalculated}
                                            icon={<CheckCircleFilled />}
                                        />
                                    </Popconfirm>
                                </Tooltip>
                            </>
                        ),
                        onCell: () => ({
                            "data-label": "Show"
                        })
                    }
                ]}
            />

            <UpdatePoolForecastModal
                poolId={poolId}
                shiftHours={shiftHours || []}
                data={selectedForecast}
                visible={updatePoolForecastModalVisible}
                setVisible={setUpdatePoolForecastModalVisible}
                recall={() => recall()}
            />
        </>
    );
};
